import { ColumnsType } from 'antd/es/table'
import { LABELS } from 'constants/txt'
import { RebateFacilityGroup } from '../types'

export type FacilityTierRow = {
  uuid: string
  key: string
  name: string
  tier?: string
  children?: FacilityTierRow[]
}

export const toFacilityTierRows = (
  groups: RebateFacilityGroup[]
): FacilityTierRow[] =>
  groups.map((group) => ({
    uuid: group.uuid,
    key: group.uuid,
    name: group.name,
    children: group.hospitals.map((hospital) => ({
      uuid: hospital.uuid,
      key: hospital.uuid,
      name: hospital.name,
      tier: hospital.tier ?? undefined
    }))
  }))

export const columns: ColumnsType<FacilityTierRow> = [
  {
    dataIndex: 'name',
    key: 'name',
    title: LABELS.FACILITIES,
    render: (name: string) => <span className="name-column">{name}</span>
  },
  {
    dataIndex: 'tier',
    key: 'tier',
    title: LABELS.TIER,
    width: 160,
    render: (tier?: string) => tier ?? ''
  }
]
